module.exports = __webpack_public_path__ + "static/media/whatsapp.b6840984.svg";